// src/components/Home.js
import React from "react";
import headshot from "../assets/images/Kimberly.jpg"; // adjust the path as needed
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faC,
  faV,
} from "@fortawesome/free-solid-svg-icons";

const Home = () => {
  return (
    <article id="top" className="wrapper style1">
      <div className="container">
        <div className="row">
          <div className="col-4 col-5-large col-12-medium">
            <span className="image fit">
              <img src={headshot} alt="" />
            </span>
            <div className="left-header-container">
              <h3>Kimberly Truong</h3>
              <p className="subtitle">Computer Science Ph.D. Student</p>
              <p className="subtitle">Carnegie Mellon University</p>
              <p className="subsubtitle">kltruong -at- cmu -dot- edu</p>
            </div>
            <ul className="contact-row">
                <li>
                  <a href="mailto:kltruong@cmu.edu" className="icon fa-envelope">
                    <span className="label">Email kltruong@cmu.edu</span>
                  </a>
                </li>
                <li>
                  <a href="https://www.linkedin.com/in/kimberly-le-truong-cs/" className="icon brands fa-linkedin-in">
                    <span className="label">LinkedIn</span>
                  </a>
                </li>
                <li>
                  <a href="https://github.com/KimberlyTruong" className="icon brands fa-github">
                    <span className="label">GitHub</span>
                  </a>
                </li>
                <li>
                  <a href="https://scholar.google.com/citations?hl=en&user=lNOgpGIAAAAJ" className="icon fa-graduation-cap">
                    <span className="label">Google Scholar</span>
                  </a>
                </li>
                <li>
                  <a href="/CV.pdf" className="icon fa-c" target="_blank" rel="noopener noreferrer">
                    <FontAwesomeIcon icon={faC} size="lg"/>
                    <FontAwesomeIcon icon={faV} size="lg"/>
                    <span className="label">CV</span>
                  </a>
                </li>
              </ul>

          </div>
          <div className="col-8 col-7-large col-12-medium">
            <header>
              <h1>
                Hi! I'm <strong>Kimberly Truong</strong>.
              </h1>
            </header>
            <p>
              I am a third year Ph.D. student at Carnegie Mellon University's
              School of Computer Science,{" "}
              <a href="https://s3d.cmu.edu">
                Software and Societal Systems Department
              </a>
              . I am co-advised by professors{" "}
              <a href="https://www.cs.cmu.edu/~hheidari/">Hoda Heidari</a> and{" "}
              <a href="https://zstevenwu.com">Steven Wu</a>. My works broadly
              explore building tools and improving algorithms to make machine
              learning systems more responsible. I am especially interested in
              advancing methods and algorithms that enable valid, actionable, and scalable evaluations of Generative AI systems.
            </p>
            <p>
              When I am not thinking about research, you can find me baking my
              latest craving, engaging in fabric crafts (crochet, embroidery,
              needle felting, sewing), hiking outdoors, social dancing, or relaxing at my local
              yoga studio! If you'd like to hear more about my work, are
              interested in collaborating, or just want to say hi, please reach
              out!
            </p>
            {/* <a href="#work" className="button large scrolly">
              Learn about what I do
            </a> */}
          </div>
        </div>
      </div>
    </article>
  );
};

export default Home;
